<template>
  <div>
    <!-- Pagination -->
    <div class="row">
      <div class="col-md-6">
        Show
        <select
          class="custom-select custom-select-sm"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
      <div class="col-md-6 text-md-right mt-2 mt-md-0">
        Sort by
        <select
          class="custom-select custom-select-sm"
          v-model="sortBy"
          style="width: 9.4em"
        >
          <option value="action">Action Date</option>
          <option value="subject">Class Subject</option>
          <option value="subjectLevel">Subject Level</option>
          <option value="duration">Duration</option>
          <option value="createdDate">Created Date</option>
          <option value="instructor">Instructor</option>
          <option value="makeup">Make-up Class</option>
          <option value="location">Location</option>
          <option value="date">Class Date</option>
          <option value="time">Class Time</option>
          <option value="status">Status</option>
        </select>
        <select
          class="custom-select custom-select-sm"
          v-model="sortDirection"
          style="width: 8em"
        >
          <option value="asc">Ascending</option>
          <option value="desc">Descending</option>
        </select>
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Result -->
    <div class="card my-3" v-for="item in classBookings" :key="item.Id">
      <div class="card-header">
        <div class="row">
          <div class="col-sm-4">
            <label class="mb-0"><b>Class Subject:</b></label>
            {{ item.SubjectName }}
          </div>
          <div class="col-sm-4">
            <label class="mb-0"><b>Subject Level:</b></label>
            {{ item.SubjectLevelName }}
          </div>
          <div class="col-sm-4">
            <label class="mb-0"><b>Duration:</b></label>
            {{ item.Duration }}
          </div>
        </div>
      </div>
      <div class="card-body pt-2 pb-0">
        <div class="row">
          <div class="col-md-10">
            <div class="form-row">
              <div class="form-group col-md-3">
                <label class="mb-0"><b>Created Date</b></label>
                <div>{{ item.SubmittedDateDisplay }}</div>
              </div>
              <div class="form-group col-md-3">
                <label class="mb-0"><b>Instructor</b></label>
                <div>{{ item.InstructorName }}</div>
              </div>
              <div class="form-group col-md-3">
                <label class="mb-0"><b>Make-up Class</b></label>
                <div>{{ item.MakeupClass }}</div>
              </div>
              <div class="form-group col-md-3">
                <label class="mb-0"><b>Location</b></label>
                <div>{{ item.Location }}</div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-3">
                <label class="mb-0"><b>Class Date</b></label>
                <div>{{ item.BookingDateDisplay }}</div>
              </div>
              <div class="form-group col-md-3">
                <label class="mb-0"><b>Class Time</b></label>
                <div>{{ item.BookingTime }}</div>
              </div>
              <div class="form-group col-md-3">
                <label class="mb-0"><b>Status</b></label>
                <div>{{ item.Status }}</div>
              </div>
              <div class="form-group col-md-3">
                <label class="mb-0"><b>Remarks</b></label>
                <div>{{ item.Remarks }}</div>
              </div>
            </div>
          </div>
          <div class="col-md-2 my-md-auto">
            <div class="row mb-3">
              <div class="form-group col-6 mb-0 text-right">
                <button
                  class="btn btn-sm btn-danger"
                  @click="cancel(item.Id)"
                  :disabled="item.Status == 'Cancelled'"
                >
                  Cancel
                </button>
              </div>
              <div class="form-group col-6 mb-0">
                <button class="btn btn-sm btn-success" @click="print(item.Id)">
                  Print
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="classBookings && !classBookings.length" class="card mt-2">
      <div class="card-body text-center">{{ noRecordText }}</div>
    </div>
    <!-- /Result -->

    <!--Pagination -->
    <div
      style="margin-top: -8px"
      class="row mb-4"
      v-if="classBookings && classBookings.length"
    >
      <div
        class="col-md-6 col-lg-6 col-sm-6 my-auto text-center text-lg-left text-md-left"
      >
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          classBookings.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-sm btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-sm btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-sm btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-sm btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->
  </div>
</template>


<script>
import API from "../../../http-common.js";
import config from "../../../config";
export default {
  props: [
    "subjectName",
    "subjectLevelName",
    "duration",
    "makeupClass",
    "statuses",
    "startDate",
    "endDate",
    "startTimeHour",
    "startTimeMinute",
    "startTimePart",
    "endTimeHour",
    "endTimeMinute",
    "endTimePart",
    "studentId",
  ],
  data() {
    return {
      noRecordText: config.NO_RECORD_TEXT,
      classBookings: [],
      paging: {
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
        SortBy: "",
      },
      sortBy: "action",
      sortDirection: "desc",
      totalRecords: "",
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
  },
  watch: {
    "paging.SizePerPage": function () {
      this.paging.CurrentPage = 1;
      this.getClassBookingList();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
    sortBy(val) {
      this.paging.CurrentPage = 1;
      if (this.sortDirection == "desc") this.paging.SortBy = `${val}_desc`;
      else this.paging.SortBy = val;
      this.getClassBookingList();
    },
    sortDirection(val) {
      this.paging.CurrentPage = 1;
      if (val == "desc") this.paging.SortBy = `${this.sortBy}_desc`;
      else this.paging.SortBy = this.sortBy;
      this.getClassBookingList();
    },
  },
  methods: {
    getClassBookingList() {
      let param = {
        Token: this.tokenObj.Token,
        CurrentPage: this.paging.CurrentPage,
        SizePerPage: this.paging.SizePerPage,
        SortBy: this.paging.SortBy,
        SchoolId: this.tokenObj.SchoolId,
        SubjectName: this.subjectName,
        SubjectLevelName: this.subjectLevelName,
        Duration: this.duration,
        MakeupClass: this.makeupClass,
        Statuses: this.statuses,
        StartDate: this.startDate,
        EndDate: this.endDate,
        StartTimeHour: this.startTimeHour,
        StartTimeMinute: this.startTimeMinute,
        StartTimePart: this.startTimePart,
        EndTimeHour: this.endTimeHour,
        EndTimeMinute: this.endTimeMinute,
        EndTimePart: this.endTimePart,
        StudentId: this.studentId,
      };
      this.$store.state.isLoading = true;
      API.classBooking
        .getClassBookingList(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.classBookings = response.data.data;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    cancel(id) {
      let param = {
        Token: this.tokenObj.Token,
        Id: id,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to cancel the class booking?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.classBooking
            .cancelClassBooking(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) this.getClassBookingList();
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    print(id) {
      let param = {
        Token: this.tokenObj.Token,
        Id: id,
      };
      API.classBooking
        .getClassBookingDetail(param)
        .then((response) => {
          if (response.data.success) {
            let data = response.data.data;

            let locationHtml = `${
              data.Location
                ? `<div class="form-row">
                <div class="form-group col-md-5">
                  <label><b>Location</b></label>
                  <div>${data.Location}</div>
                </div>
                ${
                  data.Location == "School Address"
                    ? `<div class="form-group col-md-5">
                  <label><b>School Address</b></label>
                  <div>${data.LocationSchoolAddressName}</div>
                </div>`
                    : ""
                }
              </div>`
                : ""
            }`;

            let remarksHtml = data.Remarks
              ? `<div class="form-group col-md-5">
                  <label><b>Remarks</b></label>
                    <div>${data.Remarks}</div>
                </div>`
              : "";

            let paymentHtml = "";
            if (data.MakeupClass == "No") {
              let paymentDetailHtml = "";
              if (data.PaymentOption == "Electronic Bank Transfer") {
                paymentDetailHtml = `<div class="form-row">
                    <div class="form-group col-md-5">
                      <label><b>UEN</b></label>
                      <div>${data.UEN}</div>
                    </div>
                    <div class="form-group col-md-5">
                      <label><b>SWIFT Code</b></label>
                      <div>${data.SwiftCode}</div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-5">
                      <label><b>Account Number</b></label>
                      <div>${data.AccountNumber}</div>
                    </div>
                    <div class="form-group col-md-5">
                      <label><b>Account Name</b></label>
                      <div>${data.AccountName}</div>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-5">
                      <label><b>Bank Name</b></label>
                      <div>${data.BankName}</div>
                    </div>
                    <div class="form-group col-md-5">
                      <label><b>Bank Address</b></label>
                      <div>${data.BankAddress}</div>
                    </div>
                  </div>
                  ${
                    data.paymentProof
                      ? `<div class="form-row">
                    <div class="form-group col-md-5">
                      <label><b>Payment File</b></label>
                      <div>${data.PaymentProofFileName}</div>
                    </div>
                  </div>`
                      : ""
                  }`;
              } else if (
                data.PaymentOption == "QR Payment" ||
                data.PaymentOption == "Crossed Cheque"
              ) {
                paymentDetailHtml = `<div class="form-row">
                    ${
                      data.PaymentOption == "QR Payment"
                        ? `<div class="form-group col-md-5">
                          <label><b>UEN</b></label>
                          <div>${data.UEN}</div>
                        </div>`
                        : ""
                    }
                    ${
                      data.PaymentProof
                        ? `<div class="form-group col-md-5">
                          <label><b>Payment File</b></label>
                          <div>${data.PaymentProofFileName}</div>
                        </div>`
                        : ""
                    }
                  </div>`;
              }
              paymentHtml = `<div class="card">
                <div class="card-header text-center">
                  <h3>Payment</h3>
                </div>
                <div class="card-body">
                  <div class="form-row">
                    <div class="form-group col-md-5">
                      <label><b>Total</b></label>
                      <div>
                        ${data.Currency} ${data.FeeAmountPaid}
                      </div>
                    </div>
                    <div class="form-group col-md-5">
                      <label><b>Payment Option</b></label>
                      <div>${data.PaymentOption}</div>
                    </div>
                  </div>
                  ${paymentDetailHtml}
                </div>
              </div>`;
            }

            let confirmedByHtml = "";
            if (data.ConfirmedDateDisplay) {
              confirmedByHtml = `
                <div class="form-group col-md-5">
                  <label><b>Confirmed by</b></label>
                  <div>${data.ConfirmedBy} at ${data.ConfirmedDateDisplay}</div>
                </div>`;
            } else if (
              !data.ConfirmedDateDisplay &&
              data.CancelledDateDisplay
            ) {
              confirmedByHtml = `
                <div class="form-group col-md-5">
                  <label><b>Cancelled by</b></label>
                  <div>${data.CancelledBy} at ${data.CancelledDateDisplay}</div>
                </div>`;
            }

            let cancelledByHtml = "";
            if (data.ConfirmedDateDisplay && data.CancelledDateDisplay) {
              cancelledByHtml = `
                <div class="form-row">
                  <div class="form-group col-md-5">
                    <label><b>Cancelled by</b></label>
                    <div>${data.CancelledBy} at ${data.CancelledDateDisplay}</div>
                  </div>
                </div>
              `;
            }

            let html = `<html>
            <head>
              <style>
                @media print {
                  body {
                    -webkit-print-color-adjust: exact;
                    font-family: Arial, Helvetica, sans-serif;
                  }
                }
                body{
                  font-family: Arial, Helvetica, sans-serif;
                }
                @page{size:auto; margin:5mm;}
                h3{margin: 10px;}
                .text-center{text-align: center !important;}
                .row{
                  display: -ms-flexbox;
                  display: -webkit-box;
                  display: flex;
                  -ms-flex-wrap: wrap;
                  flex-wrap: wrap;
                  margin-right: -15px;
                  margin-left: -15px;
                }
                .form-row{
                  display: -ms-flexbox;
                  display: -webkit-box;
                  display: flex;
                  -ms-flex-wrap: wrap;
                  flex-wrap: wrap;
                  margin-right: -5px;
                  margin-left: -5px;
                }
                .form-group{
                  margin-bottom: 1rem;
                }
                .form-group label{
                  margin-bottom: 0.25rem;
                }
                .col-md-6{
                  -ms-flex: 0 0 46%;
                  -webkit-box-flex: 0;
                  flex: 0 0 46%;
                  max-width: 46%;
                  position: relative;
                  width: 100%;
                  padding-right: 15px;
                  padding-left: 15px;
                }
                .col-md-5{
                  -ms-flex: 0 0 41%;
                  -webkit-box-flex: 0;
                  flex: 0 0 41%;
                  max-width: 41%;
                  position: relative;
                  width: 100%;
                  padding-right: 15px;
                  padding-left: 15px;
                }
                .card{
                  border: 1px solid #a7a7a7;
                  -webkit-box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.2);
                  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.2);
                  margin-bottom: 30px;
                  position: relative;
                  display: -ms-flexbox;
                  display: -webkit-box;
                  display: flex;
                  -ms-flex-direction: column;
                  -webkit-box-orient: vertical;
                  -webkit-box-direction: normal;
                  flex-direction: column;
                  min-width: 0;
                  word-wrap: break-word;
                  background-color: #fff;
                  background-clip: border-box;
                  border-radius: 0.25rem;
                }
                .card-header:first-child{
                  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
                }
                .card-header{
                  background-color: #fff;
                  padding: 0rem 1.25rem;
                  margin-bottom: 0;
                  border-bottom: 1px solid #a7a7a7;
                }
                .card-body{
                  font-size: 14px;
                  -ms-flex: 1 1 auto;
                  -webkit-box-flex: 1;
                  flex: 1 1 auto;
                  min-height: 1px;
                  padding-top: 0.5rem;
                  padding-bottom: 0.5rem;
                }
              </style>
            </head>
            <body>
              <div class="row">
                <div class="col-md-6">
                  <div class="card">
                    <div class="card-header text-center">
                      <h3>Booking Summary</h3>
                    </div>
                    <div class="card-body">
                      <div class="form-row">
                        <div class="form-group col-md-5">
                          <label><b>Submitted by</b></label>
                          <div>${data.SubmittedBy} at ${data.SubmittedDateDisplay}</div>
                        </div>
                        <div class="form-group col-md-5">
                          <label><b>School</b></label>
                          <div>${data.SchoolName}</div>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-5">
                          <label><b>Name</b></label>
                          <div>${data.StudentName}</div>
                        </div>
                        <div class="form-group col-md-5">
                          <label><b>Email</b></label>
                          <div>${data.StudentEmail}</div>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-5">
                          <label><b>Class Subject</b></label>
                          <div>${data.SubjectName}</div>
                        </div>
                        <div class="form-group col-md-5">
                          <label><b>Subject Level</b></label>
                          <div>${data.SubjectLevelName}</div>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-5">
                          <label><b>Duration</b></label>
                          <div>${data.Duration}</div>
                        </div>
                        <div class="form-group col-md-5">
                          <label><b>Make-up Class</b></label>
                          <div>${data.MakeupClass}</div>
                        </div>
                      </div>
                      ${locationHtml}
                      <div class="form-row">
                        <div class="form-group col-md-5">
                          <label><b>Date</b></label>
                          <div>${data.BookingDateDisplay}</div>
                        </div>
                        <div class="form-group col-md-5">
                          <label><b>Time</b></label>
                          <div>${data.BookingTime} (${data.TimezoneName})</div>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-5">
                          <label><b>Instructor</b></label>
                          <div>${data.InstructorName}</div>
                        </div>
                        ${remarksHtml}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  ${paymentHtml}
                  <div class="card">
                    <div class="card-header text-center">
                      <h3>Status</h3>
                    </div>
                    <div class="card-body">
                      <div class="form-row">
                        <div class="form-group col-md-5">
                          <label><b>Status</b></label>
                          <div>${data.Status}</div>
                        </div>
                        ${confirmedByHtml}
                      </div>
                      ${cancelledByHtml}
                    </div>
                  </div>
                </div>
              </div>
            </body>
            </html>`;
            // let w = window.open("", "PRINT", "height=700,width=1300");
            // w.document.write(html);
            // // for i.e
            // w.document.close();
            // w.focus();
            // //for the rest
            // window.setTimeout(() => {
            //   w.print();
            //   w.close();
            // }, 500);

            // let userAgent = navigator.userAgent;
            // let isAndroid = /Android/i.test(userAgent);
            // let isIOS = /iPhone|iPad|iPod/i.test(userAgent);

            const printFrame = document.createElement("iframe");
            printFrame.style.position = "absolute";
            printFrame.style.width = "0";
            printFrame.style.height = "0";
            printFrame.style.border = "none";
            document.body.appendChild(printFrame);
            const printDocument =
              printFrame.contentWindow || printFrame.contentDocument;
            printDocument.document.open();
            printDocument.document.write(html);
            printDocument.document.close();
            printFrame.contentWindow.focus();
            try {
              printFrame.contentWindow.print();
            } catch (e) {
              console.log(e.message);
            }
            printFrame.contentWindow.onafterprint = () => {
              document.body.removeChild(printFrame);
            };
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    //pagination
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getClassBookingList();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getClassBookingList();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getClassBookingList();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getClassBookingList();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getClassBookingList();
    },
  },
  created() {
    this.getClassBookingList();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SchoolUser/Student/MyClassesTableFormat.vue